import type { Parceiro } from "./tipos"

// Newbe (newbe.com.br), a plataforma de RH que leva o consignado aos clientes dela. Cores e fontes
// tiradas do site deles.
//
// Uma troca deliberada: o rosa do site é #ef2563, mas branco sobre ele dá 4,11:1 — abaixo dos 4,5:1
// que texto pequeno precisa, e o destaque dos números carrega texto pequeno. #e51152 é o mesmo
// matiz e a mesma saturação, só a luminosidade que baixa o mínimo para passar (4,63:1). Vale
// confirmar com o time de marca da Newbe.
export const NEWBE: Parceiro = {
    slug: "newbe",
    nome: "Newbe",
    doParceiro: "da Newbe",
    comArtigo: "a Newbe",
    tituloDaAba: "Newbe · Portal do Empregador",
    // O ícone do próprio logo oficial, recortado sem o nome.
    favicon: "/brand/newbe-favicon.png",
    // O arquivo oficial, enviado pela própria Newbe. A versão para fundo escuro é a mesma arte com o
    // nome recolorido para a tinta do tema escuro — o ícone rosa fica intacto.
    marca: {
        tipo: "imagem",
        claro: "/brand/newbe.webp",
        escuro: "/brand/newbe-branco.webp",
        alt: "Newbe",
    },
    dominios: [],
    operadoPelaFazCred: true,
    tema: {
        claro: {
            brand: "#e51152",
            "brand-ink": "#ffffff",
            "brand-strong": "#c30e46",
            "brand-wash": "#fde4ec",
            // O violeta da Newbe, e não o rosa, é o neutro dos gráficos: rosa ao lado do vermelho de
            // "barrado" dá 1,59:1 — as duas fatias viram a mesma.
            data: "#5d58f7",
            page: "#f9fafb",
            card: "#ffffff",
            sunk: "#eef1f5",
            ink: "#282835",
            soft: "#3d3f3f",
            faint: "#6d6e70",
            line: "#e2e8f0",
            "line-strong": "#cbd5e1",
        },
        escuro: {
            brand: "#ff5c8a",
            "brand-ink": "#191a21",
            "brand-strong": "#ff85a8",
            "brand-wash": "#4a152a",
            data: "#8f8bff",
            page: "#0f1014",
            card: "#191a21",
            sunk: "#242630",
            ink: "#f3f4f6",
            soft: "#dfe2e8",
            faint: "#b3b9c4",
            line: "#2b2d38",
            "line-strong": "#40434f",
        },
    },
    fontes: {
        titulo: '"Montserrat Variable", ui-sans-serif, system-ui, sans-serif',
        texto: '"Montserrat Variable", ui-sans-serif, system-ui, sans-serif',
        numeros: '"Quicksand Variable", ui-sans-serif, system-ui, sans-serif',
        carregar: () =>
            Promise.all([
                import("@fontsource-variable/montserrat"),
                import("@fontsource-variable/quicksand"),
            ]),
    },
}
